import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emptyValueValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const inputValue: unknown = control.value,
        isString: boolean = typeof inputValue === 'string', /** This check need to filter Autocomplete values **/
        isEmptyInputValue: boolean = !(inputValue && isString && control.value.trim().length);

  return isString && isEmptyInputValue ? {'required': true} : null;
};
